module.exports = __webpack_public_path__ + "static/mobile-app-img-4-07c431c3e2d05a35fcd9730f654c347f.png";